var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2 1.89a7.83 7.83 0 0 1-2.26.64A4 4 0 0 0 18.67.3a8 8 0 0 1-2.5 1A3.88 3.88 0 0 0 13.29 0a4 4 0 0 0-3.94 4 3.93 3.93 0 0 0 .11 1A11.1 11.1 0 0 1 1.34.74a4.09 4.09 0 0 0 1.22 5.39 3.87 3.87 0 0 1-1.79-.5 4 4 0 0 0 3.16 4 4 4 0 0 1-1 .14 3.64 3.64 0 0 1-.74-.07 3.94 3.94 0 0 0 3.68 2.8 7.73 7.73 0 0 1-4.93 1.74c-.32 0-.63 0-.94-.05A11 11 0 0 0 6 16c7.25 0 11.21-6.16 11.21-11.49v-.52a8.21 8.21 0 0 0 2-2.1",
    fill: "#231f20",
    "data-name": "NoBox/Twitter"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1267c54e37b5972b56fe43ccd2573171.svg";
export { ForwardRef as ReactComponent };